import { render } from "./HeadTitle.vue?vue&type=template&id=59223daa&scoped=true"
import script from "./HeadTitle.vue?vue&type=script&lang=js"
export * from "./HeadTitle.vue?vue&type=script&lang=js"

import "./HeadTitle.vue?vue&type=style&index=0&id=59223daa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59223daa"]])

export default __exports__